import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const TickCircleSolidIcon = forwardRef<SVGSVGElement, IconProps>(function TickCircleSolidIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 0C4.041 0 0 4.041 0 9C0 13.959 4.041 18 9 18C13.959 18 18 13.959 18 9C18 4.041 13.959 0 9 0ZM13.302 6.93L8.199 12.033C8.073 12.159 7.902 12.231 7.722 12.231C7.542 12.231 7.371 12.159 7.245 12.033L4.698 9.486C4.437 9.225 4.437 8.793 4.698 8.532C4.959 8.271 5.391 8.271 5.652 8.532L7.722 10.602L12.348 5.976C12.609 5.715 13.041 5.715 13.302 5.976C13.563 6.237 13.563 6.66 13.302 6.93Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
